exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/**\n * Themings and color for POS app\n */\n.options-card {\n  margin-top: 7px !important;\n}\n.options-card.serving-options {\n  height: 350px;\n}\n.servingOptionSubMenu-margin {\n  margin-top: 10px !important;\n}\n.servingOption-menuItems {\n  margin-top: 50px !important;\n}\n.servingOptions-padding {\n  padding-top: 18px !important;\n}\n.servingOption-reset-container {\n  margin-top: 15px !important;\n  display: flex !important;\n  justify-content: flex-end !important;\n}\n.servingOption-reset-icon {\n  margin-top: 10px !important;\n  display: flex !important;\n  align-items: center !important;\n  float: right !important;\n  height: 25px !important;\n  width: 25px !important;\n  cursor: pointer;\n  color: #4b8bb1;\n}\n.servingOption-increment {\n  float: right !important;\n}\n.text-center {\n  text-align: center !important;\n}\n.time-delay .pos-button {\n  margin-top: 10px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/pages/pointofsale/styles/components/servingOptions.less
// module id = 3116
// module chunks = 0